module MetaHelper

open Browser.Dom
open Shared

type MetaData = {
    Title: string
    Description: string
    Keywords: string
    OgTitle: string
    OgDescription: string
    OgImage: string
}

let updateMetaTag (name: string) (content: string) =
    let existingTag = document.querySelector(sprintf "meta[name='%s']" name)
    match existingTag with
    | null ->
        let newTag = document.createElement("meta") :?> Browser.Types.HTMLMetaElement
        newTag.setAttribute("name", name)
        newTag.setAttribute("content", content)
        document.head.appendChild(newTag) |> ignore
    | tag ->
        tag.setAttribute("content", content)

let updatePropertyTag (property: string) (content: string) =
    let existingTag = document.querySelector(sprintf "meta[property='%s']" property)
    match existingTag with
    | null ->
        let newTag = document.createElement("meta") :?> Browser.Types.HTMLMetaElement
        newTag.setAttribute("property", property)
        newTag.setAttribute("content", content)
        document.head.appendChild(newTag) |> ignore
    | tag ->
        tag.setAttribute("content", content)

let updateCanonicalLink (url: string) =
    let existingLink = document.querySelector("link[rel='canonical']")
    match existingLink with
    | null ->
        let newLink = document.createElement("link") :?> Browser.Types.HTMLLinkElement
        newLink.setAttribute("rel", "canonical")
        newLink.setAttribute("href", url)
        document.head.appendChild(newLink) |> ignore
    | link ->
        link.setAttribute("href", url)

let applyMetaData (metaData: MetaData) =
    document.title <- metaData.Title

    updateMetaTag "description" metaData.Description
    updateMetaTag "keywords" metaData.Keywords

    updatePropertyTag "og:title" metaData.OgTitle
    updatePropertyTag "og:description" metaData.OgDescription
    updatePropertyTag "og:image" metaData.OgImage
    updatePropertyTag "og:type" "website"
    updatePropertyTag "og:site_name" "Functor"

    updateMetaTag "twitter:card" "summary_large_image"
    updateMetaTag "twitter:title" metaData.OgTitle
    updateMetaTag "twitter:description" metaData.OgDescription
    updateMetaTag "twitter:image" metaData.OgImage

let applyHomeMetaData () =
    let baseUrl = "https://functor.team"
    let metaData = {
        Title = "Functor"
        Description = "Create and launch your own IT solutions. Establish ongoing cooperation with our experienced F# developers."
        Keywords = "F#, development, Sweden, Flutter, React, web applications, mobile applications, Functor, digital transformation"
        OgTitle = "Functor"
        OgDescription = "Create and launch your own IT solutions. Establish ongoing cooperation with our experienced F# developers."
        OgImage = baseUrl + "/img/symbol.png"
    }
    applyMetaData metaData
    updateCanonicalLink (baseUrl + "/")